"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetToUsernameAuth = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const resetToUsernameAuth = exports.resetToUsernameAuth = (0, _actionGenerator.actionGenerator)(_types.EStateActionTypes.ResetStateToUsernameAuth);